import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { EnvironmentDTO } from "@reflag/shared/environmentAPI";

import { environmentQueryKeys } from "./environmentQueryKeys";

export const useEnvironmentData = <TData = EnvironmentDTO>(
  envId?: string,
  queryOptions?: Omit<
    UseQueryOptions<EnvironmentDTO, AxiosError<ErrorResponse>, TData>,
    "queryKey" | "queryFn" | "initialData"
  > & { initialData?: () => undefined },
) => {
  const { appId } = useEnvironment();

  return useQuery({
    queryKey: environmentQueryKeys.single(appId, envId),

    queryFn: () =>
      api
        .get<"/apps/:appId/environments/:envId">(
          `/apps/${appId}/environments/${envId}`,
        )
        .then((res) => res.data),
    enabled: !!appId && !!envId,
    ...queryOptions,
  });
};
